import React, { useState } from 'react';
import './Welcome.css';

const Welcome = ({ onEnter }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleEnter = () => {
    setIsAnimating(true);
    setTimeout(() => {
      onEnter();
    }, 800);
  };

  return (
    <div className={`welcome-container ${isAnimating ? 'fade-out' : ''}`}>
      <div className="welcome-content">
        <div className="welcome-header">
          <div className="logo-animation">
            <span className="logo-icon">✈️</span>
          </div>
          <h1 className="welcome-title">
            <span className="title-greeting">Hola, Juan Sepúlveda </span>
            <span className="title-line">Planificador de Viajes</span>
          </h1>
        </div>

        <div className="welcome-destinations">
          <h2 className="destinations-title">Destinos que te esperan</h2>
          <div className="destinations-grid">
            <div className="destination-card europe">
              <div className="destination-overlay"></div>
              <div className="destination-content">
                <span className="destination-icon">🏛️</span>
                <h3>Europa</h3>
                <p>Explora ciudades históricas y culturas fascinantes</p>
              </div>
            </div>
            <div className="destination-card middle-east">
              <div className="destination-overlay"></div>
              <div className="destination-content">
                <span className="destination-icon">🕌</span>
                <h3>Medio Oriente</h3>
                <p>Descubre tradiciones milenarias y paisajes únicos</p>
              </div>
            </div>
            <div className="destination-card americas">
              <div className="destination-overlay"></div>
              <div className="destination-content">
                <span className="destination-icon">🌎</span>
                <h3>América</h3>
                <p>Vive aventuras desde el norte hasta el sur</p>
              </div>
            </div>
          </div>
        </div>

        

        <button className="enter-button" onClick={handleEnter}>
          <span>Comenzar Planificación</span>
          <span className="button-arrow">→</span>
        </button>

        <div className="welcome-footer">
          <p>Organiza tus viajes como un profesional</p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;

